import { H2, BodyText } from "src/atoms/typography";
import IconOnBackground from "src/components/IconOnBackground";
import { SceneLayout } from "src/components/SceneLayout";
import NavigationButtons from "src/components/NavigationButtons";
import { Button } from "@chakra-ui/react";

export default function DevicesOnly({
  deviceName,
  t,
  onPair,
  onReject,
  onClose,
  mode,
  icon
}) {
  return (
    <>
      <NavigationButtons onBack={onReject} onClose={onClose} mode={mode} />

      <SceneLayout
        centerProps={{ width: "320px" }}
        center={
          <>
            <IconOnBackground icon={icon} bg="primaryLight" fill="primary" />
            <H2 textAlign="center" color="highEmphasis" mt="24px">
              {t("pairing.requester.devicesOnly.heading", {
                value0: deviceName
              })}
            </H2>
            <BodyText textAlign="center" color="mediumEmphasis" mt="8px">
              {t("pairing.requester.devicesOnly.text")}
            </BodyText>
          </>
        }
        bottom={
          <>
            <Button var="containedPrimary" onClick={onPair} minWidth="120px">
              {t("buttons.pair")}
            </Button>
            <Button
              variant="flatPrimary"
              onClick={onReject}
              minWidth="120px"
              mt="8px"
              mb="16px"
            >
              {t("buttons.reject")}
            </Button>
          </>
        }
      />
    </>
  );
}
